import React from 'react';
import styled from 'styled-components';
import { A, P } from '@upsolve/ui';
import { get, upperFirst } from 'lodash';

import ImageInContext from '../Media/ImageInContext';

const MAX_BIO_LENGTH = 280;

const AuthorBioWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: 0.5em 0;
  box-shadow: 0 5px 15px -5px rgba(0, 0, 0, 0.1);
  padding: 0.5em 0.75em;
  border-radius: 6px;

  .author-image, img {
    height: 48px;
    width: 48px;
    min-height: 48px;
    min-width: 48px;
    border-radius: 36px;
  }

  p {
    margin-left: 0.75em;
    font-size: 14px;
  }
`;

const AuthorBio = ({ author }) => (
  <AuthorBioWrapper>
    <div>
      <ImageInContext
        className="author-image"
        alt={get(author, 'name', '')}
        src={get(author, 'image.image.file.url')}
        fluid={get(author, 'image.image.fluid')}
      />
    </div>
    <div>
      <P>
        <b>
          <A aria-busy="false" href={`/authors/${author.slug}/`}>{upperFirst(author.name)}</A>
        </b>
        <br />
        {!!get(author, 'biography.biography') && author.biography.biography.length > MAX_BIO_LENGTH
          ? (<span>{`${author.biography.biography.slice(0, MAX_BIO_LENGTH).trim()}...`}<A aria-busy="false" href={`/authors/${author.slug}/`}> read more</A></span>)
          : get(author, 'biography.biography', '')
        }
      </P>
    </div>
  </AuthorBioWrapper>
);

export default AuthorBio;
